// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Reader from "../Control.Monad.Reader/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foliage_App_Style from "../Foliage.App.Style/index.js";
import * as Foliage_Common from "../Foliage.Common/index.js";
import * as Foliage_Program from "../Foliage.Program/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML from "../Halogen.HTML/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM);
var pure = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var map = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var render = /* #__PURE__ */ Foliage_Program.render(Foliage_Program["_Render_Prop"]);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_List_Types.foldableList)(Data_List_Types.monoidList);
var render1 = /* #__PURE__ */ Foliage_Program.render(Foliage_Program["_Render_Rule"]);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Common["_Show_Exc"]({
    reflectSymbol: function () {
        return "error";
    }
}));
var OkResult = /* #__PURE__ */ (function () {
    function OkResult(value0) {
        this.value0 = value0;
    };
    OkResult.create = function (value0) {
        return new OkResult(value0);
    };
    return OkResult;
})();
var PendingResult = /* #__PURE__ */ (function () {
    function PendingResult() {

    };
    PendingResult.value = new PendingResult();
    return PendingResult;
})();
var ErrResult = /* #__PURE__ */ (function () {
    function ErrResult(value0) {
        this.value0 = value0;
    };
    ErrResult.create = function (value0) {
        return new ErrResult(value0);
    };
    return ErrResult;
})();
var SetResult = /* #__PURE__ */ (function () {
    function SetResult(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SetResult.create = function (value0) {
        return function (value1) {
            return new SetResult(value0, value1);
        };
    };
    return SetResult;
})();
var SetIntermediateEnv = /* #__PURE__ */ (function () {
    function SetIntermediateEnv(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SetIntermediateEnv.create = function (value0) {
        return function (value1) {
            return new SetIntermediateEnv(value0, value1);
        };
    };
    return SetIntermediateEnv;
})();
var Ran = /* #__PURE__ */ (function () {
    function Ran() {

    };
    Ran.value = new Ran();
    return Ran;
})();
var Run = /* #__PURE__ */ (function () {
    function Run() {

    };
    Run.value = new Run();
    return Run;
})();
var component = /* #__PURE__ */ (function () {
    var initialState = function (input) {
        return {
            result: Data_Maybe.Nothing.value,
            intermediate_env: Data_Maybe.Nothing.value,
            mod: input.mod
        };
    };
    var handleQuery = function (v) {
        if (v instanceof SetResult) {
            return discard(modify_(function (v1) {
                var $25 = {};
                for (var $26 in v1) {
                    if ({}.hasOwnProperty.call(v1, $26)) {
                        $25[$26] = v1[$26];
                    };
                };
                $25.result = v.value0;
                return $25;
            }))(function () {
                return pure(new Data_Maybe.Just(v.value1));
            });
        };
        if (v instanceof SetIntermediateEnv) {
            return discard(modify_(function (v1) {
                var $30 = {};
                for (var $31 in v1) {
                    if ({}.hasOwnProperty.call(v1, $31)) {
                        $30[$31] = v1[$31];
                    };
                };
                $30.intermediate_env = v.value0;
                return $30;
            }))(function () {
                return pure(new Data_Maybe.Just(v.value1));
            });
        };
        throw new Error("Failed pattern match at Foliage.App.Viewer.Component (line 63, column 17 - line 69, column 20): " + [ v.constructor.name ]);
    };
    var handleAction = function (v) {
        return Halogen_Query_HalogenM.raise(Ran.value);
    };
    var getRenderCtx = function (state) {
        return {
            mod: state.mod
        };
    };
    var renderEnv = function (state) {
        return function (v) {
            return [ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_column) ])(Data_Array.concat([ append([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.bold) ])([ Halogen_HTML_Core.text("known_props") ]) ])(fromFoldable(map((function () {
                var $52 = Data_Function.flip(Control_Monad_Reader.runReader)(getRenderCtx(state));
                return function ($53) {
                    return Halogen_HTML.fromPlainHTML(Halogen_HTML_Elements.span_($52(Foliage_Program.line(render($53)))));
                };
            })())(fold(Data_Map_Internal.values(v.known_props))))), append([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.bold) ])([ Halogen_HTML_Core.text("active_props") ]) ])(fromFoldable(map(function (v1) {
                return Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_row) ])([ Halogen_HTML_Elements.div([  ])([ Halogen_HTML_Core.text("[new:" + ((function () {
                    if (v1.isNew) {
                        return "T";
                    };
                    return "F";
                })() + "]")) ]), Halogen_HTML.fromPlainHTML(Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(getRenderCtx(state))(Foliage_Program.line(render(v1.prop))))) ]);
            })(v.active_props))), append([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.bold) ])([ Halogen_HTML_Core.text("ripe_rules") ]) ])(fromFoldable(map((function () {
                var $54 = Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_column) ]);
                var $55 = map((function () {
                    var $57 = Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.margin_small)(append(Foliage_App_Style.padding_small)(Foliage_App_Style.boundaries))) ]);
                    var $58 = Data_Function.flip(Control_Monad_Reader.runReader)(getRenderCtx(state));
                    return function ($59) {
                        return Halogen_HTML.fromPlainHTML($57($58(render1(Foliage_Program.from_RipeRule_to_Rule($59)))));
                    };
                })());
                return function ($56) {
                    return $54(fromFoldable($55($56)));
                };
            })())(Data_Map_Internal.values(v.ripe_rules)))) ])) ];
        };
    };
    var render2 = function (state) {
        return Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.font_code)(append(Foliage_App_Style.flex_column)([ "gap: 1.0em" ]))) ])(Data_Array.concat([ [ Halogen_HTML_Elements.div([  ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_row) ])([ Halogen_HTML_Elements.div([  ])([ Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(Data_Function["const"](Run.value)), Foliage_App_Style.style(Foliage_App_Style.button) ])([ Halogen_HTML_Core.text("Run") ]) ]) ]) ]) ], [ Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.font_code)(append(Foliage_App_Style.flex_column)([ "overflow: scroll" ]))) ])((function () {
            if (state.intermediate_env instanceof Data_Maybe.Just) {
                return renderEnv(state)(state.intermediate_env.value0);
            };
            if (state.intermediate_env instanceof Data_Maybe.Nothing) {
                if (state.result instanceof Data_Maybe.Nothing) {
                    return [  ];
                };
                if (state.result instanceof Data_Maybe.Just && state.result.value0 instanceof ErrResult) {
                    if (state.result.value0.value0.env instanceof Data_Maybe.Nothing) {
                        return [ Halogen_HTML_Core.text(show(state.result.value0.value0.err)) ];
                    };
                    if (state.result.value0.value0.env instanceof Data_Maybe.Just) {
                        return append(renderEnv(state)(state.result.value0.value0.env.value0))([ Halogen_HTML_Core.text(show(state.result.value0.value0.err)) ]);
                    };
                    throw new Error("Failed pattern match at Foliage.App.Viewer.Component (line 132, column 43 - line 134, column 82): " + [ state.result.value0.value0.env.constructor.name ]);
                };
                if (state.result instanceof Data_Maybe.Just && state.result.value0 instanceof PendingResult) {
                    return [ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.font_prose) ])([ Halogen_HTML_Core.text("running...") ]) ];
                };
                if (state.result instanceof Data_Maybe.Just && state.result.value0 instanceof OkResult) {
                    return renderEnv(state)(state.result.value0.value0.env);
                };
                throw new Error("Failed pattern match at Foliage.App.Viewer.Component (line 130, column 28 - line 139, column 65): " + [ state.result.constructor.name ]);
            };
            throw new Error("Failed pattern match at Foliage.App.Viewer.Component (line 128, column 103 - line 139, column 65): " + [ state.intermediate_env.constructor.name ]);
        })()) ] ]));
    };
    var $$eval = Halogen_Component.mkEval({
        receive: Halogen_Component.defaultEval.receive,
        initialize: Halogen_Component.defaultEval.initialize,
        finalize: Halogen_Component.defaultEval.finalize,
        handleQuery: handleQuery,
        handleAction: handleAction
    });
    return Halogen_Component.mkComponent({
        initialState: initialState,
        "eval": $$eval,
        render: render2
    });
})();
export {
    SetResult,
    SetIntermediateEnv,
    OkResult,
    PendingResult,
    ErrResult,
    Ran,
    Run,
    component
};
